import { socketService } from '../socketService';
import { SocketEventType, SocketMessage } from '../types';
import { AIModel } from '../../types/AIModels';
import { SummaryType } from '../../store/research/types';
import { AggregationOptions } from '../../store/summaryTest/types';

interface PredefinedSummaryPayload {
  type: 'predefined';
  companyId: string;
  promptName: SummaryType;
}

interface CustomSummaryPayload {
  type: 'custom';
  companyId: string;
  prompt: string;
  maxCharsPerSection?: number | null;
  selectedDocuments: {
    [documentId: string]: { selectedSectionIdx: number[]; useEmbeddings: boolean };
  };
  model?: AIModel | null;
  aggregationOptions?: AggregationOptions | null;
}

export type GenerateSummaryPayload = PredefinedSummaryPayload | CustomSummaryPayload;

export interface GenerateSummaryResponse {
  success: boolean;
  error?: string;
}

export const generateSummary = async (
  request: GenerateSummaryPayload,
): Promise<GenerateSummaryResponse> => {
  const message: SocketMessage<GenerateSummaryPayload> = {
    type: SocketEventType.GenerateSummary,
    payload: request,
    timestamp: new Date().toISOString(),
  };

  const response = await socketService.emitWithAck<GenerateSummaryPayload, GenerateSummaryResponse>(
    SocketEventType.GenerateSummary,
    message,
  );

  return response;
};
